export default __webpack_public_path__ + "MasterCard.3a292121.svg";